<template>
  <div class="row justify-content-between mt-3 mb-4">
    <div class="col-md-12">
      <div class="white-card ml-0 p-4">

        <OperationBilanTable
          :items-charges="itemsCharges"
          :items-global="itemsGlobal"
          :items-lots="itemsLots"
          :table-fields-charges="tableFieldsCharges"
          :table-fields-global="tableFieldsGlobal"
          :table-fields-lots="tableFieldsLots">
        </OperationBilanTable>

        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Finish') }}</b-button>
          </div>

        </b-form>
      </div>
    </div>
  </div>
</template>

<script>

import OperationBilanTable from "../components/OperationBilanTable";
import api from "../../../services/api.js";

export default {
  name: "OperationBilanTotal",

  components: {
    OperationBilanTable
  },

  props: {
    operationId: {
      type: Number,
      default: null
    },
    simulationId: {
      type: Number,
      default: null
    }
  },


  data() {
    return {
      operationBilanId: this.$route.params.operationBilanId,
      operationId: this.$route.params.operationId,
      operation: {
        name: null,
        id: null
      },
      tableFieldsCharges: [
        {label: '', key: 'type'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsCharges: [],

      tableFieldsLots: [
        {label: 'Lot', key: 'lot'},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'TTC', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsLots: [],

      tableFieldsGlobal: [
        {label: 'Balance financière professionnelle', key: 'nom'},
        {label: '%', key: 'taux', thStyle: {width: "15%"}},
        {label: 'HT', key: 'HT', thStyle: {width: "15%"}},
        {label: 'TVA', key: 'TVA', thStyle: {width: "15%"}},
        {label: 'Montant', key: 'TTC', thStyle: {width: "15%"}},
      ],
      itemsGlobal: [],
    }
  },

  async mounted() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      if (this.operationId) {
        await this.fetchOperation()
      }
      await this.fetchBilanData()
    },

    async fetchOperation() {
      api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.operation.name = response.data.name
          this.operation.id = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchBilanData() {
      api
        .get(`/operationBilan/getBilanData/${this.operationId}`)
        .then(response => {
          this.itemsCharges = response.data['itemsCharges']
          this.itemsLots = response.data['itemsLots']
          this.itemsGlobal = response.data['itemsGlobal']
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    back() {
      this.$confirm(this.$i18n.t('Back.confirm').toString()).then(() => {
        this.$router.go(-1)
      });
    },

    async fetchOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async onSubmit() {
      if (this.operationId) {
        await this.fetchOperationBilanId()
        await this.generateMonthlyCharges()
      }
      await this.$router.push({
        name: 'OperationShow',
        params: {
          operationId: this.operationId,
          currentSection: 0,
          operationBilanId: this.operationBilanId
        }
      })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationBilan/bilanCreateEditSteps/OperationBilanTotal.vue